import React from 'react'
import { CmsLink, CmsLinkComponent } from '../../..'

import { MediaImage } from '../../../cmsTypes/mediaImage'

interface FooterLogoProps {
    copyrightText: string
    image: MediaImage
    link: CmsLink
}

export const FooterLogo: React.FC<FooterLogoProps> = props => {
    const copyrightText = props.copyrightText
        ? props.copyrightText
        : '© 2024 FatCats Entertainment<br>2989 W Maple Loop Dr. #100<br>Lehi, UT 84043, USA<br>'

    let link = props?.link
    if (!link || !link?.url) {
        link = {
            name: '',
            target: '',
            url: '/',
        }
    }

    return (
        <div className="footer-logo">
            <CmsLinkComponent link={link}>
                <img src={props.image.url} className="logo-image" alt="Fat Cats Fun" />
            </CmsLinkComponent>
            <div className="footer-copyright">
                <a dangerouslySetInnerHTML={{ __html: copyrightText }} />
            </div>
        </div>
    )
}

export default FooterLogo
